import { datadogLogs } from '@datadog/browser-logs';
import { string as zString } from 'zod';

const PUBLIC_DATADOG_KEY = zString({
  required_error: 'Missing PUBLIC_DATADOG_KEY from process.env',
}).parse(process.env.PUBLIC_DATADOG_KEY);

const DD_ENV = process.env.PUBLIC_DD_ENV;

export function initialize() {
  datadogLogs.init({
    env: DD_ENV,
    service: 'web',
    clientToken: PUBLIC_DATADOG_KEY,
    forwardErrorsToLogs: true,
  });
}

export function getLogger() {
  if (datadogLogs.getInitConfiguration() === undefined) {
    initialize();
  }

  return datadogLogs.logger;
}
